import React from 'react';
import i18next from 'i18next';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';

import { chatWs } from '../../websocketController';

import rulesIcon from 'icons/rules.svg';
import onlineIcon from 'icons/people.svg';
import arrowIcon from 'icons/arrow.svg';

export default class SideBottom extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      online: 0,
    };
  }

  componentDidMount() {
    chatWs.sub('users', this.onDataReceived);
  }

  componentWillUnmount() {
    chatWs.unsub('users', this.onDataReceived);
  }

  onDataReceived = (data) => {
    const type = data.type;
    if (type === 'online') {
      this.setState({ online: data.payload.count });
    }
  };

  render() {
    const { online } = this.state;
    return (
      <div className="sidebottom">
        <div className="sidebottom__info">
          <div className="text-icon">
            <Icon glyph={rulesIcon} className="text-icon__icon" />
            <Link to="/rules" className="link">
              {i18next.t('blocks.rules')}
            </Link>
          </div>
          <div className="text-icon">
            <Icon glyph={onlineIcon} className="text-icon__icon" />
            <span className="sidebottom__online">
              {online} {i18next.t('online')}
            </span>
          </div>
        </div>
        <div className="sidebottom__toggle btn" onClick={this.props.toggleMenu}>
          <Icon glyph={arrowIcon} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SideBottom/SideBottom.jsx